//异常数据
import _import from '@/utils/import'
const Layout = _import('layout/Layout')
let conCard = [
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'conCard',//消费量区域分布
        component: _import('conCard/conCardAll/index'),
        name: 'conCard',
        meta: {
          title: '消费卡区域分布',
          icon: 'widgets'
        }
      },{
        path: 'conCardProvince',//省市数据
        component: _import('conCard/conProvince/index'),
        name: 'conCardProvince',
        meta: { 
          title: '消费卡区域分布',
          icon: 'widgets'
        }
      },{
        path: 'conCardDot',//地市数据
        component: _import('conCard/conDot/index'),
        name: 'conCardDot',
        meta: { 
          title: '消费卡区域分布',
          icon: 'widgets'
        }
      },
    ]
  }
]
export default conCard;